import styled from "styled-components";

import {
  GEO_ACCENT_LIME,
  GEO_DISMISS_BG,
  GEO_MODAL_BG,
  GEO_OVERLAY_Z_INDEX,
} from "../../lib/geoBanner/config";

export const StyledGeoOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${GEO_OVERLAY_Z_INDEX};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(19, 18, 18, 0.55);
  backdrop-filter: blur(2px);
`;

export const StyledGeoModal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 420px;
  padding: 56px 40px;
  background: ${GEO_MODAL_BG};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  text-align: left;
`;

export const StyledGeoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 38px;
  width: 100%;
`;

export const StyledGeoCopy = styled.p`
  margin: 0;
  max-width: 338px;
  font-size: 19px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.38px;
  color: ${({ theme }) => theme.colors.white};
  word-break: break-word;

  strong {
    font-weight: 700;
  }
`;

export const StyledGeoBannerActions = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
`;

const actionButtonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 281px;
  max-width: 100%;
  padding: 16px;
  border: none;
  border-radius: 200px;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.32px;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
  white-space: nowrap;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  &:hover,
  &:focus-visible {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${GEO_ACCENT_LIME};
    outline-offset: 3px;
  }
`;

export const StyledGeoBannerCta = styled.a`
  ${actionButtonBase}
  background: ${GEO_ACCENT_LIME};
  color: ${({ theme }) => theme.colors.black};
`;

export const StyledGeoBannerDismiss = styled.button`
  ${actionButtonBase}
  background: ${GEO_DISMISS_BG};
  color: ${({ theme }) => theme.colors.white};
`;
